import { __extends } from "tslib";
import { Subscriber } from '../Subscriber';
import { lift } from '../util/lift';
import { Subscription } from '../Subscription';
import { from } from '../observable/from';
export function catchError(selector) {
    return function (source) {
        return lift(source, function (source) {
            var subscriber = this;
            var subscription = new Subscription();
            var innerSub = null;
            var syncUnsub = false;
            var handledResult;
            var handleError = function (err) {
                try {
                    handledResult = from(selector(err, catchError(selector)(source)));
                }
                catch (err) {
                    subscriber.error(err);
                    return;
                }
            };
            innerSub = source.subscribe(new CatchErrorSubscriber(subscriber, function (err) {
                handleError(err);
                if (handledResult) {
                    if (innerSub) {
                        innerSub.unsubscribe();
                        innerSub = null;
                        subscription.add(handledResult.subscribe(subscriber));
                    }
                    else {
                        syncUnsub = true;
                    }
                }
            }));
            if (syncUnsub) {
                innerSub.unsubscribe();
                innerSub = null;
                subscription.add(handledResult.subscribe(subscriber));
            }
            else {
                subscription.add(innerSub);
            }
            return subscription;
        });
    };
}
var CatchErrorSubscriber = (function (_super) {
    __extends(CatchErrorSubscriber, _super);
    function CatchErrorSubscriber(destination, onError) {
        var _this = _super.call(this, destination) || this;
        _this.onError = onError;
        return _this;
    }
    CatchErrorSubscriber.prototype._error = function (err) {
        this.onError(err);
        this.unsubscribe();
    };
    return CatchErrorSubscriber;
}(Subscriber));
//# sourceMappingURL=catchError.js.map